import { render, staticRenderFns } from "./VendorGuide.vue?vue&type=template&id=1b665b64"
import script from "./VendorGuide.vue?vue&type=script&lang=js"
export * from "./VendorGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports